<app-breadcrumb-mkt [title]="title" [routeBase]="route"/>



<div class="table-responsive" xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
  <div class="d-flex justify-content-end  ">
    <button (click)="cleanId()" class="btn  btn-outline-secondary ms-2" data-bs-toggle="modal" data-bs-target="#addHomeHero"><i
      class="bi bi-plus-circle"></i> Agregar
    </button>
  </div>
  <table class="table">
    <thead>
    <tr>
      <th scope="col">#</th>
      <th class="w-45" scope="col">Nombre Camapaña</th>
      <th scope="col">Link Whatsapp</th>
      <th scope="col">Imagen</th>
      <th scope="col">Acciones</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of dataHerosHome; let i = index">
      <th scope="row">{{ i + 1 }}</th>
      <td>{{ item.nameCampana }}</td>
      <td><a href="{{ item.linkWhatsapp }}" target="_blank" class="btn btn-success"><i class="bi bi-whatsapp"></i></a></td>
      <td>
        <img style="width: 100px" src="{{imgUrl}}{{ item.imagenUrl }}" alt="imgEspecialidad">
      </td>
      <td>

        <button class="btn btn-outline-secondary" (click)="deleteHomeHero(item._id)"><i class="bi bi-trash" ></i>
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<div class="modal fade" id="addHomeHero" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Agregar Home Hero</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formDataForCreateHomeHero" class="row g-3 needs-validation" novalidate>
          <div class="col-md-6">
            <label for="nameCamapana" class="form-label">Nombre de la campaña</label>
            <input formControlName="nameCampana" type="text" class="form-control" id="nameCamapana"  required>
            <div style="color:red;" *ngIf="formDataForCreateHomeHero.get('nameCampana')?.errors?.['required']">El nombre es obligatorio. </div>

          </div>
          <div class="col-md-6">
            <label for="numeroWhatsapp" class="form-label">Whatsapp Numero</label>
            <input formControlName="numeroWhatsapp" type="text" class="form-control" id="numeroWhatsapp"   required>

          </div>
          <div class="col-md-12">
            <label for="mensaje" class="form-label">Mensaje Predeterminado de Whatsapp</label>
            <textarea formControlName="linkWhatsapp" type="text" class="form-control" id="mensaje" required></textarea>
            <div style="color:red;" *ngIf="formDataForCreateHomeHero.get('linkWhatsapp')?.errors?.['required']">El mensaje es obligatorio. </div>

          </div>
          <div class="col-md-12">
            <label for="imagen" class="form-label">Image Hero</label>
            <input #inputImage class="form-control" id="imagen" type="file" accept="image/*"  (change)="capturarArchivo($event)">
<!--            <div style="color:red;" *ngIf="formDataForCreateHomeHero.get('imagenUrl')?.errors?.['required']">La imágen es obligatoria. </div>-->
            <div class="input-group image">
              <img width="100%" [src]="preview" alt="">
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button  type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
        <button (click)="sendAllData()" [disabled]="isLoading" type="button" class="btn btn-primary"> <span class="text" *ngIf="!isLoading">Guardar </span></button>
      </div>
    </div>
  </div>
</div>



<app-notifications/>
